export const UISelectors = {
  loading(state) {
    return state.ui.loading;
  },
  notification(state) {
    return state.ui.notification;
  },
};
